import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, withDefaults } from "vue"

  interface Props {
    cor: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AAmostraDeCor',
  props: {
    cor: { default: "gray" }
  },
  setup(__props: any) {

const props = __props as { cor: string }

  

  const estiloDinamico = computed(() => {
    return {
      backgroundColor: props.cor,
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "AAmostraDeCor",
    "data-testid": "a-amostra-de-cor",
    style: _normalizeStyle(_unref(estiloDinamico))
  }, null, 4))
}
}

})